import React from "react";
import BookmarkBorderIcon from "@material-ui/icons/BookmarkBorder";

const Works = () => {
  return (
    <div>
      <h1 className="title text-center">Works</h1>

      <div className="works text-left">
        <div className="repo-card-div">
          <a href="google.com" target="_blank" rel="noreferrer">
            <div className="repo-name-div">
              <BookmarkBorderIcon />
              <p className="repo-name">single-page-resume-builder</p>
            </div>

            <p className="repo-description">
              Create a simple react resume builder project using html, css,
              React.
            </p>
            <div className="repo-stats">
              <div className="repo-left-stat"></div>
              <div className="repo-right-stat">
                <p>548 KB</p>
              </div>
            </div>
          </a>
        </div>

        <div className="repo-card-div">
          <a
            href="https://github.com/rakeshnayak360/simple-weather-app"
            target="_blank"
            rel="noreferrer"
          >
            <div className="repo-name-div">
              <BookmarkBorderIcon />
              <p className="repo-name">simple-weather-app</p>
            </div>

            <p className="repo-description">
              Created a simple weather App using ReactJS, Styled Component and
              third-party weather API.
            </p>
            <div className="repo-stats">
              <div className="repo-left-stat"></div>
              <div className="repo-right-stat">
                <p>39 KB</p>
              </div>
            </div>
          </a>
        </div>

        <div className="repo-card-div">
          <a
            href="https://github.com/rakeshnayak360/gradient-generator"
            target="_blank"
            rel="noreferrer"
          >
            <div className="repo-name-div">
              <BookmarkBorderIcon />
              <p className="repo-name">gradient-generator</p>
            </div>

            <p className="repo-description">
              This is a simple gradient generator built using ReactJS.
            </p>
            <div className="repo-stats">
              <div className="repo-left-stat"></div>
              <div className="repo-right-stat">
                <p>200 KB</p>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Works;
